<app-adloop-card [class]="'display-block full-height ' + backgroundImgClass">
  <app-form-builder
    [form]="form"
    [formDef]="formDef"
    [errors]="errors"
    (onSubmit)="submit()"></app-form-builder>
</app-adloop-card>
